var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6601 175.57V67.57L74.9401 55.57V171.35C81.193 167.743 86.3855 162.553 89.9948 156.302C93.6042 150.05 95.503 142.959 95.5001 135.74V0L44.1001 60V176.9H54.3801C57.8492 176.893 61.3035 176.446 64.6601 175.57V175.57Z",
    fill: "#37A56E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.19 187.15V98.53L105.78 38.53V135.72C105.767 149.349 100.347 162.416 90.7113 172.054C81.0751 181.692 68.009 187.114 54.38 187.13H21V200H126.35V94.14L136.63 106.14V200H179V187.15H157.19Z",
    fill: "#3B3D3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTower);
export default __webpack_public_path__ + "static/media/tower.eb62b7d32c2c7c25dd3424a798dbfc06.svg";
export { ForwardRef as ReactComponent };